module.exports = __webpack_public_path__ + "static/media/list.be33add6.csv";